import { useResourceContext, useCreatePath, useTranslate } from "ra-core";
import { useNavigate } from "react-router";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

/**
 * Back button of the fixed header of every mobile detail and form page. It
 * goes to `to` when given, otherwise to the list of the current resource.
 */
export const MobileBackButton = (props: { resource?: string; to?: string }) => {
  const resource = useResourceContext(props);
  const navigate = useNavigate();
  const createPath = useCreatePath();
  const translate = useTranslate();
  const { to } = props;
  const finalTo =
    to ??
    createPath({
      resource,
      type: "list",
    });

  return (
    <Button
      type="button"
      variant="ghost"
      size="icon"
      className="-ml-2 mr-1 shrink-0 rounded-full"
      aria-label={translate("ra.action.back")}
      onClick={(e) => {
        e.preventDefault();
        navigate(finalTo);
      }}
    >
      <ArrowLeft className="size-5" />
    </Button>
  );
};
